import React, { Component } from 'react';
import Moment from 'react-moment';
import 'moment-timezone';

class CreatedDateCell extends Component {
  render() {
    const value = this.props.dataItem.createdAt;
    return (
      <td>
        <Moment format="MM-DD-YYYY">{value}</Moment>
      </td>
    );
  }
}

export default CreatedDateCell;
